import { render } from "./ChildListView.vue?vue&type=template&id=356e757d&scoped=true&ts=true"
import script from "./ChildListView.vue?vue&type=script&lang=ts"
export * from "./ChildListView.vue?vue&type=script&lang=ts"

import "./ChildListView.vue?vue&type=style&index=0&id=356e757d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356e757d"]])

export default __exports__